import { ModalService } from 'src/app/shared/services/modal/modal.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { remove } from 'lodash';
import { forkJoin } from 'rxjs';
import { Variete } from 'src/app/data/declaration/models/variete.model';
import { VarieteService } from 'src/app/data/declaration/services/parcellaire/variete.service';
import { LoaderService } from '../../../../../../../../core/services/loader/loader.service';

@Component({
    selector: 'app-liste-clones',
    templateUrl: './liste-clones.component.html',
    styleUrls: ['./liste-clones.component.scss'],
    standalone: false
})
export class ListeClonesComponent implements OnInit {
    varietes: Variete[];

    constructor(
        private readonly loaderService: LoaderService,
        private readonly modalsService: ModalService,
        private readonly translate: TranslateService,
        private readonly varieteService: VarieteService,
        private readonly router: Router,
        private readonly route: ActivatedRoute
    ) {}

    ngOnInit() {
        forkJoin(this.varieteService.getVarietesClone())
            .pipe(this.loaderService.operator())
            .subscribe(([varietes]) => {
                this.varietes = varietes;
            });
    }

    openConfirmationDialog(variete: Variete) {
        this.modalsService
            .confirm('Veuillez confirmer', 'Voulez vous supprimer ' + this.translate.instant('label.clone') + variete.libelle + ' ?', {
                cancelText: this.translate.instant('label.annuler'),
                submitText: this.translate.instant('label.confirmer'),
                windowClass: 'anpp'
            })
            .then(() => {
                this.deleteVariete(variete);
            });
    }

    deleteVariete(variete: Variete) {
        this.varieteService.desactiverVariete(variete).subscribe(() => {
            remove(this.varietes, variete);
        });
    }

    editVariete(variete: Variete) {
        this.modalsService
            .confirm('Veuillez confirmer', this.translate.instant('page.valeur_parametrable.message_modification'), {
                cancelText: this.translate.instant('label.annuler'),
                submitText: this.translate.instant('label.confirmer'),
                windowClass: 'anpp'
            })
            .then(() => {
                this.router.navigate(['edit', variete.id], { relativeTo: this.route });
            });
    }
}
